import type { CategoryCard } from "@/types";

interface CategoryGridProps {
  subtitle: string;
  titleLine1: string;
  titleLine2: string;
  cards: CategoryCard[];
}

export default function CategoryGrid({ subtitle, titleLine1, titleLine2, cards }: CategoryGridProps) {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <p className="font-heading text-xs md:text-sm text-foreground-500 italic font-medium">
            {subtitle}
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mt-2">
            {titleLine1}
            <br />
            <span className="font-script text-primary-500 italic font-semibold">
              {titleLine2}
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, idx) => (
            <a
              key={idx}
              href={card.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group rounded-2xl overflow-hidden cursor-pointer transition-transform hover:-translate-y-1 ${card.bgClass}`}
            >
              <div className="h-56 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={`${card.name} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`${card.labelBgClass} p-5`}>
                <h3 className="text-foreground-950 font-heading text-lg font-bold">{card.name}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}